var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoVolt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 491,
    height: 490,
    viewBox: "0 0 491 490",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(10 10)",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("ellipse", {
    stroke: "#1A63AB",
    strokeWidth: 19,
    cx: 235.52,
    cy: 234.88,
    rx: 235.52,
    ry: 234.88
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#1A63AB",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M67 209.634h20.948l29.91 67.297 29.728-67.297h20.945l-46.49 100.406h-8.348L67 209.634zm304.073-25.606v25.605h29.465v17.815l-29.465-.001v48.947c0 11.106 4.95 15.465 16.946 15.634l.366.004.374.001c3.252 0 6.878-.313 11.224-.969l1.016-.157 2.641-.42v16.98l-1.778.4c-6.44 1.444-11.727 2.173-16.205 2.173-21.32 0-33.82-11.235-34.069-32.05l-.003-.634v-49.909h-15.896v-17.813l15.896-.001v-25.605h19.488zm-146.994 25.605l.776.01.805-.004c26.881.07 49.598 22.145 49.94 48.535l.005.8-.011.771.01.764c.108 26.274-22.673 48.998-49.345 49.345l-.81.004-.78-.01-.774.01c-26.62.106-49.243-22.228-49.764-48.53l-.008-.799.004-.79-.01-.766c-.111-26.539 22.402-49.001 49.15-49.336l.812-.004zM315.81 159v150.621h-19.488V159h19.488zm-91.47 69.036c-17.176-.073-31.773 14.534-31.401 31.71-.25 17.099 14.396 32.077 31.796 31.702.174.004.348.006.522.007l.52-.003c16.954-.23 31.374-14.949 31.006-31.706.368-17.003-13.932-31.368-30.881-31.7l-.52-.006-.521.003-.522-.007zM168.466 159h-99.57v16.992h99.57z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoVolt);
export default __webpack_public_path__ + "static/media/logo-volt.72e965309ebc1fc9a2ba7859c58668c7.svg";
export { ForwardRef as ReactComponent };